import { a as __spreadArray } from '../../chunks/bundle-t6JaUd1b.js';
import React__default, { useContext, useState, useEffect } from 'react';
import { i as isDisabledBecauseFrozen, b as isDisabledBecauseMuted, c as isOperator } from '../../chunks/bundle-4PBxOF7r.js';
import MessageInput from '../../ui/MessageInput.js';
import QuoteMessageInput from '../../ui/QuoteMessageInput.js';
import { L as LocalizationContext } from '../../chunks/bundle-KjVIQqaY.js';
import { u as useChannelContext } from '../../chunks/bundle-oaL-WZdX.js';
import { useSendbirdStateContext } from '../../useSendbirdStateContext.js';
import SuggestedMentionList from './SuggestedMentionList.js';
import { M as MessageInputKeys } from '../../chunks/bundle-rcUMtSzr.js';
import { V as VoiceMessageInputWrapper } from '../../chunks/bundle-Zzg_Wc7p.js';
import { useDirtyGetMentions } from '../../Message/hooks/useDirtyGetMentions.js';
import { u as useMediaQueryContext } from '../../chunks/bundle-ior2BlUD.js';
import { useHandleUploadFiles } from '../hooks/useHandleUploadFiles.js';
import '../../chunks/bundle-jJZAQH44.js';
import '../../chunks/bundle-vAvSNdmj.js';
import '../../chunks/bundle-NZcldiSn.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-2axFKCIx.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-XlrrUjEJ.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-mxq273ll.js';
import '../../chunks/bundle-olZmltOQ.js';
import '../../chunks/bundle-zL2GggA_.js';
import 'dompurify';
import '../../chunks/bundle-mO3J4SXS.js';
import '../../chunks/bundle-Q-3uYmLU.js';
import '../../chunks/bundle-iGWTklyk.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-f-bQSvmA.js';
import '../../chunks/bundle-nyXhTs2k.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-v7nqMv6h.js';
import '../../chunks/bundle-79RbKDD4.js';
import '../../chunks/bundle-mW5agIOj.js';
import '../../chunks/bundle-l9d09gzQ.js';
import '@sendbird/chat/groupChannel';
import '../../chunks/bundle-hEvM6x_9.js';
import '../hooks/useInitialMessagesFetch.js';
import '../../chunks/bundle-KF1IhHsV.js';
import '../../chunks/bundle-joPrRU5E.js';
import '../../chunks/bundle-EvZinAAd.js';
import '../../chunks/bundle-fe2EF_iJ.js';
import '../../withSendbird.js';
import '../../chunks/bundle-vVdAEhWk.js';
import '../../chunks/bundle-gdweDZjg.js';
import '../../Thread/context.js';
import '../../Thread/context/types.js';
import '@sendbird/chat';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-jzsK-B6H.js';
import '../../VoiceRecorder/context.js';
import '../../chunks/bundle-q1M15U1p.js';
import 'react-dom';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-uDxWy2vD.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ProgressBar.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-yND4UFpN.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-21p8ODP_.js';

var MessageInputWrapper = function (props, ref) {
    var _a;
    var value = props.value, renderFileUploadIcon = props.renderFileUploadIcon, renderVoiceMessageIcon = props.renderVoiceMessageIcon, renderSendMessageIcon = props.renderSendMessageIcon;
    var propDisabled = props.disabled;
    var channelContext = useChannelContext();
    var currentGroupChannel = channelContext.currentGroupChannel, initialized = channelContext.initialized, quoteMessage = channelContext.quoteMessage, sendMessage = channelContext.sendMessage, sendFileMessage = channelContext.sendFileMessage, sendVoiceMessage = channelContext.sendVoiceMessage, sendMultipleFilesMessage = channelContext.sendMultipleFilesMessage, setQuoteMessage = channelContext.setQuoteMessage, messageInputRef = channelContext.messageInputRef, renderUserMentionItem = channelContext.renderUserMentionItem;
    var globalStore = useSendbirdStateContext();
    var isMobile = useMediaQueryContext().isMobile;
    var channel = currentGroupChannel;
    var _b = globalStore.config, isOnline = _b.isOnline, isMentionEnabled = _b.isMentionEnabled, userMention = _b.userMention, isVoiceMessageEnabled = _b.isVoiceMessageEnabled, logger = _b.logger;
    var isMultipleFilesMessageEnabled = ((_a = channelContext.isMultipleFilesMessageEnabled) !== null && _a !== void 0 ? _a : globalStore.config.isMultipleFilesMessageEnabled);
    var maxUserMentionCount = (userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount) || 10;
    var maxUserSuggestionCount = (userMention === null || userMention === void 0 ? void 0 : userMention.maxSuggestionCount) || 15;
    var stringSet = useContext(LocalizationContext).stringSet;
    var _c = useState(''), mentionNickname = _c[0], setMentionNickname = _c[1];
    // todo: set type
    var _d = useState([]), mentionedUsers = _d[0], setMentionedUsers = _d[1];
    var _e = useState([]), mentionedUserIds = _e[0], setMentionedUserIds = _e[1];
    var _f = useState(null), selectedUser = _f[0], setSelectedUser = _f[1];
    var _g = useState([]), mentionSuggestedUsers = _g[0], setMentionSuggestedUsers = _g[1];
    var _h = useState(null), messageInputEvent = _h[0], setMessageInputEvent = _h[1];
    var _j = useState(false), showVoiceMessageInput = _j[0], setShowVoiceMessageInput = _j[1];
    var disabled = propDisabled
        || !initialized
        || isDisabledBecauseFrozen(channel)
        || isDisabledBecauseMuted(channel)
        || !isOnline;
    var isOperator$1 = isOperator(channel);
    var isBroadcast = channel === null || channel === void 0 ? void 0 : channel.isBroadcast;
    var displaySuggestedMentionList = isOnline
        && isMentionEnabled
        && mentionNickname.length > 0
        && !isDisabledBecauseFrozen(channel)
        && !isDisabledBecauseMuted(channel)
        && !isBroadcast;
    // Reset when channel changes
    useEffect(function () {
        setMentionNickname('');
        setMentionedUsers([]);
        setMentionedUserIds([]);
        setSelectedUser(null);
        setMentionSuggestedUsers([]);
        setMessageInputEvent(null);
        setShowVoiceMessageInput(false);
    }, [channel === null || channel === void 0 ? void 0 : channel.url]);
    var mentionNodes = useDirtyGetMentions({ ref: ref || messageInputRef }, { logger: logger });
    var ableMention = (mentionNodes === null || mentionNodes === void 0 ? void 0 : mentionNodes.length) < maxUserMentionCount;
    useEffect(function () {
        setMentionedUsers(mentionedUsers.filter(function (_a) {
            var userId = _a.userId;
            var i = mentionedUserIds.indexOf(userId);
            if (i < 0) {
                return false;
            }
            else {
                mentionedUserIds.splice(i, 1);
                return true;
            }
        }));
    }, [mentionedUserIds]);
    // MFM
    var handleUploadFiles = useHandleUploadFiles({
        sendFileMessage: sendFileMessage,
        sendMultipleFilesMessage: sendMultipleFilesMessage,
        quoteMessage: quoteMessage,
    }, {
        logger: logger,
    });
    // broadcast channel + not operator
    if (isBroadcast && !isOperator$1) {
        return null;
    }
    // other conditions
    return (React__default.createElement("div", { className: "sendbird-message-input-wrapper".concat(showVoiceMessageInput ? '--voice-message' : '') },
        displaySuggestedMentionList && (React__default.createElement(SuggestedMentionList, { targetNickname: mentionNickname, inputEvent: messageInputEvent, renderUserMentionItem: renderUserMentionItem, onUserItemClick: function (user) {
                if (user) {
                    setMentionedUsers(__spreadArray(__spreadArray([], mentionedUsers, true), [user], false));
                }
                setMentionNickname('');
                setSelectedUser(user);
                setMessageInputEvent(null);
            }, onFocusItemChange: function () {
                setMessageInputEvent(null);
            }, onFetchUsers: function (users) {
                setMentionSuggestedUsers(users);
            }, ableAddMention: ableMention, maxMentionCount: maxUserMentionCount, maxSuggestionCount: maxUserSuggestionCount })),
        quoteMessage && (React__default.createElement("div", { className: "sendbird-message-input-wrapper__quote-message-input" },
            React__default.createElement(QuoteMessageInput, { replyingMessage: quoteMessage, onClose: function () { return setQuoteMessage(null); } }))),
        showVoiceMessageInput
            ? (React__default.createElement(VoiceMessageInputWrapper, { channel: channel, onSubmitClick: function (recordedFile, duration) {
                    sendVoiceMessage(recordedFile, duration, quoteMessage);
                    setQuoteMessage(null);
                    setShowVoiceMessageInput(false);
                }, onCancelClick: function () {
                    setShowVoiceMessageInput(false);
                } }))
            : (React__default.createElement(MessageInput, { className: "sendbird-message-input-wrapper__message-input", value: value, channelUrl: channel === null || channel === void 0 ? void 0 : channel.url, mentionSelectedUser: selectedUser, isMentionEnabled: isMentionEnabled, isVoiceMessageEnabled: isVoiceMessageEnabled, isSelectingMultipleFilesEnabled: isMultipleFilesMessageEnabled, onVoiceMessageIconClick: function () {
                    setShowVoiceMessageInput(true);
                }, setMentionedUsers: setMentionedUsers, channel: channel, placeholder: (quoteMessage && stringSet.MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER)
                    || (isDisabledBecauseFrozen(channel) && stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED)
                    || (isDisabledBecauseMuted(channel) && (isMobile ? stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED_SHORT : stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED)), ref: ref || messageInputRef, disabled: disabled, renderFileUploadIcon: renderFileUploadIcon, renderSendMessageIcon: renderSendMessageIcon, renderVoiceMessageIcon: renderVoiceMessageIcon, onStartTyping: function () {
                    channel === null || channel === void 0 ? void 0 : channel.startTyping();
                }, onSendMessage: function (_a) {
                    var _b;
                    var message = _a.message, mentionTemplate = _a.mentionTemplate;
                    sendMessage({
                        message: message,
                        quoteMessage: quoteMessage,
                        mentionedUsers: mentionedUsers,
                        mentionTemplate: mentionTemplate,
                    });
                    setMentionNickname('');
                    setMentionedUsers([]);
                    setQuoteMessage(null);
                    (_b = channel === null || channel === void 0 ? void 0 : channel.endTyping) === null || _b === void 0 ? void 0 : _b.call(channel);
                }, onFileUpload: function (fileList) {
                    handleUploadFiles(fileList);
                    setQuoteMessage(null);
                }, onUserMentioned: function (user) {
                    if ((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.userId) === (user === null || user === void 0 ? void 0 : user.userId)) {
                        setSelectedUser(null);
                        setMentionNickname('');
                    }
                }, onMentionStringChange: function (mentionText) {
                    setMentionNickname(mentionText);
                }, onMentionedUserIdsUpdated: function (userIds) {
                    setMentionedUserIds(userIds);
                }, onKeyDown: function (e) {
                    if (displaySuggestedMentionList && (mentionSuggestedUsers === null || mentionSuggestedUsers === void 0 ? void 0 : mentionSuggestedUsers.length) > 0
                        && ((e.key === MessageInputKeys.Enter && ableMention) || e.key === MessageInputKeys.ArrowUp || e.key === MessageInputKeys.ArrowDown)) {
                        setMessageInputEvent(e);
                        return true;
                    }
                    return false;
                } }))));
};
var MessageInputWrapper$1 = React__default.forwardRef(MessageInputWrapper);

export { VoiceMessageInputWrapper, MessageInputWrapper$1 as default };
//# sourceMappingURL=MessageInput.js.map
